import { Box, Button, Icon, ModalBody, Text } from '@bechtel/gds';
import { useTranslation } from 'react-i18next';
import { ModalCloseStyled } from '../../../../styles';
import { ModalFooterStyled, ModalHeaderStyled, ModalStyled } from '../styled';

interface ConfirmLockToolRoomProps {
  onConfirm?: () => void;
  onClose?: () => void;
  toolRoom?: string;
}

export function ConfirmLockToolRoomDialog({ onConfirm, onClose, toolRoom }: ConfirmLockToolRoomProps) {
  const { t } = useTranslation();
  return (
    <ModalStyled visible={true}>
      <ModalHeaderStyled title={`${t('REVIEW')} ${toolRoom}`}>
        <ModalCloseStyled onClick={onClose}></ModalCloseStyled>
      </ModalHeaderStyled>
      <ModalBody>
        <Box mt={{ sm: '300' }} gap={{ sm: '400' }} p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
          <Text size={'500'} color="grey.700" family={'openSansSemiBold'}>
            {`${t('LOCK_REQUISITION_TOOL_ROOM_CONFIRMATION')} ${toolRoom}`}
          </Text>
          <Text family={'openSansCondensed'} size={'400'} color="neutral.600">
            {t('LOCK_TOOL_ROOM_SUB_MESSAGE')}
          </Text>
        </Box>
      </ModalBody>
      <ModalFooterStyled>
        <Box justifyContent={{ sm: 'space-between' }} gap={{ sm: '500' }} alignItems={{ sm: 'center' }}>
          <Box>
            {/* after confirmation can use this code */}
            {/* <Box gap={{ sm: '200' }}>
              <Text family={theme.fontFamilies.openSansCondensed} weight={'600'} size={'300'} color="black">
                {t('NO_OF_ITEMS')}
              </Text>
              <Text family={theme.fontFamilies.openSansCondensed} weight={'600'} size={'300'} color="grey.500">
                {totalItems}
              </Text>
            </Box>

            <Box gap={{ sm: '200' }}>
            
               <Text family={theme.fontFamilies.openSansCondensed} weight={'600'} size={'300'} color="black">
                {t('Total Quantities:')}
              </Text>
              <Text family={theme.fontFamilies.openSansCondensed} weight={'600'} size={'300'} color="grey.500">
                {totalQuantities}
              </Text> 
            </Box> */}
          </Box>
          {onConfirm && (
            <Box>
              <Button css={{ minWidth: '100px', gap: 10 }} onClick={onConfirm}>
                <Icon icon="check" /> {t('CONFIRM')}
              </Button>
            </Box>
          )}
        </Box>
      </ModalFooterStyled>
    </ModalStyled>
  );
}
